import React, { Component, useEffect, useState } from 'react'
import { PropTypes } from 'prop-types'
import { useAuth0 } from '@auth0/auth0-react';
import $ from 'jquery'
import { Button, Card, Alert, Container, Modal, Row, Col } from "react-bootstrap";
import { Redirect, Link } from 'react-router-dom'
import { JsonFormatter } from 'react-json-formatter'

import {  EntitiesAPI } from "../../components/apis";
import history from '../../history';
import Loading from '../../components/common/Loading';
import config from '../../config';
import { useisLoading } from '../../hook/useisLoading';
import { getEntities } from './helpers/entitiesHelper';
import ErrorMessage from '../../components/common/ErrorMessage';

export const Entities = (props, context) => {

    console.log("Enter into Entities.js...");
    
    const [application, setApplication] = useState(props.application);
    const [account, setAccount] = useState(props.account);    
    
    const [apiEntities, setApiEntities] = useState(null);

    const { user : userAuth0, getAccessTokenSilently } = useAuth0();
    
    const { isLoading, showSpinner, hideSpinner } = useisLoading(true);

    const [apiActionErr, setApiActionErr] = useState(null);
    const [apiErr, setApiErr] = useState(null);
    const [error502, setError502] = useState(0);
    const [alertVisible, setAlertVisible] = useState(true);

    const [entities, setEntities] = useState(null);

    const [stack, setStack] = useState(null);
    const [showFullDescription, setShowFullDescription] = useState(false);
    const [showBasicDescription, setShowBasicDescription] = useState(false);
    const [fullDescriptionName, setFullDescriptionName] = useState(null);
    const [fullDescriptionContent, setFullDescriptionContent] = useState(null);


    const handleBasicDescription = ( entityName) => {

        apiEntities.getBasicDescription(application.appInstance_name, entityName)
            .then((response) => {
                setStack(null);
                setShowFullDescription(true);
                setFullDescriptionName(entityName);
                setFullDescriptionContent(response);
            }).catch((err) => {
                console.log("Error on handleBasicDescription.")
                setApiErr(err);
            });
      };
    
    const hideBasicDescription = ( entityName) => {
        setShowBasicDescription(false);
    }

    const hideFullDescription = ( entityName) => {
        setShowFullDescription(false);
    }
    
    const handleFullDescription = ( entityName) => {
    
        apiEntities.getFullDescription(application.appInstance_name, entityName)
            .then((response) => {
                setStack(null);
                setShowFullDescription(true);
                setFullDescriptionName(entityName);                
                setFullDescriptionContent(response);
            }).catch((err) => {
                console.log("Error on handleFullDescription.")
                setApiErr(err);
            });
    };

    const retry = () => {

        setApiErr(null);
        setAlertVisible(true);
        showSpinner();
        setEntities([]);
        getEntities(context, apiEntities, application.appInstance_name, hideSpinner, setEntities, setApiActionErr, setApiErr, error502, setError502);
    }
    
    const dismiss = () => {
        setAlertVisible(false);
    }
    
    const goBack = () => {
        history.goBack();
    }

    useEffect(() => {

        getAccessTokenSilently({audience: config.get('auth0.audience'),}).then( response => {
            const api = new EntitiesAPI(response, application.id);
            setApiEntities(api);
        });     
        
    }, [])

    useEffect(() => {
        if (apiEntities && application){    
            getEntities(context, apiEntities, application.appInstance_name, hideSpinner, setEntities, setApiActionErr, setApiErr, error502, setError502);
        }
    }, [apiEntities, error502])
    

    
    if (isLoading) {
        return (
            <Loading />
        )
    } else {

        if (apiErr) {
            return (
                <div>
                    <Container fluid>
                        <ErrorMessage message={apiErr}/>
                        <div className="error__content">
                            <br/>
                            <Button onClick={ () => retry() }><i className="material-icons">refresh</i> {context.t('Reload')}</Button>
                        </div>
                    </Container>
                </div>
            )
        }
        
        return (
            <div>
                <Modal size="lg" show={ showFullDescription } onHide={ () => hideFullDescription() } aria-labelledby="example-modal-sizes-title-lg" >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-modal-sizes-title-lg">Entity Name: {fullDescriptionName}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <JsonFormatter json={JSON.stringify(fullDescriptionContent)} tabWith="2" JsonStyle={{
                                propertyStyle: { color: "red" },
                                stringStyle: { color: "green" },
                                numberStyle: { color: "darkorange" },
                        }}/>
                    </Modal.Body>
                </Modal>
                
                {(apiActionErr)?
                    <ErrorMessage message={apiActionErr.message}/>
                :""}

                <Container fluid className='px-0'>
                    <Card id="UG_entitiesTable" className="snx-card px-0">
                        <Card.Header className="border-bottom text-center">
                            <h5 className="mb-0"> {context.t('Entities')} </h5>
                        </Card.Header>
                        <Card.Body className="pt-0 px-0" >
                            <Container style={{ padding:"25px", }}>
                                <Row>
                                    <table id="entitiesListTable" className='snx-table-list'>
                                        <thead><tr><th></th></tr></thead>   
                                        <tbody>
                                        {entities && entities.length > 0 ? (
                                        entities &&
                                        entities.map((entity) => {
                                            return (
                                                <tr key={entity.name} style={{ margin: "10px"}}>
                                                    <td>
                                                        <Card className="snx-card-list-thin">
                                                            <Card.Body className="snx-card-body-list-thin">
                                                                <Row>
                                                                    <Col>
                                                                        <i className="material-icons md-24" style={{ float: "left", cursor:"default", }} >label_outline</i>
                                                                        <span id="UG_entityName" style={{ float: "left", marginTop: "2px", marginLeft: "6px", cursor:"default", }} > {entity.name} </span>
                                                                    </Col>
                                                                    <Col className="pull-right">
                                                                        <Link target={`${application.appInstance_name}-${entity.name}-swagger`} className="mb-2 mr-1 pull-right" to={`/accounts/${account.name}/applications/${application.id}/entities/${entity.name}/swagger`}>
                                                                            <Button id="UG_entitySwagger" onClick={(e) => {}} className="snx-btn-action border-0" style={{padding:"0px"}}>
                                                                                <img src="../../../images/swagger-gray.svg" height="15px" width="15px" loading="lazy" alt="Swagger" title="Swagger" />   
                                                                            </Button>

                                                                        </Link>
                                                                        <Button id="UG_entityFullDetail" onClick={ () => { handleFullDescription(entity.name) }} className="snx-btn-action pull-right" style={{padding:"0px", fontSize:"18px"}}>
                                                                            <i className="material-icons" height="15px" width="15px" >description</i>
                                                                        </Button>
                                                                        <Button id="UG_entityBasicDetail" onClick={ () => { handleBasicDescription(entity.name) }} className="snx-btn-action pull-right" style={{padding:"0px", fontSize:"18px"}}>
                                                                            <i className="material-icons" height="105px" width="15px" >insert_drive_file</i>
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            </Card.Body>
                                                        </Card>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                        ) : (
                                            <tr>
                                                <td>
                                                    <Alert className="mb-0 info">
                                                        <i className="fa fa-info mx-2"></i>{" "} {context.t("No items loaded")}
                                                    </Alert>
                                                    <br />
                                                </td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </table>
                                </Row>
                            </Container>
                        </Card.Body>
                    </Card>
                </Container>
                <br />
                <br />
            </div>
        )
    }
}

Entities.contextTypes = {
    t: PropTypes.func.isRequired
}

export default Entities;